var map = {
	"./_Alberto.png": 525,
	"./_Anna.png": 1852,
	"./_Antonio.png": 9516,
	"./_Baldo.png": 6510,
	"./_Canguro.png": 8095,
	"./_Claudia.png": 5955,
	"./_Fausta.png": 1876,
	"./_Federica.png": 1951,
	"./_Flavia.png": 2607,
	"./_Luca.png": 8199,
	"./_Manuela.png": 4999,
	"./_Max.png": 5974,
	"./_Nadia.png": 8055,
	"./_RiccardoCeppari.png": 9959,
	"./_Silvia.png": 7454
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2103;